import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/theme/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "code"
    }}>{`Code`}</h1>
    <p>{`This is an inline `}<inlineCode parentName="p">{`code`}</inlineCode>{` example`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-markdown"
      }}>{`This is an inline \`code\` example
`}</code></pre>
    <h2 {...{
      "id": "block"
    }}>{`Block`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-markup"
      }}>{`<button type="button">Click Me!</button>
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`\`\`\`markup
<button type="button">Click Me!</button>
\`\`\`
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      